// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"88c1dd64","977":"55e1ec72"}[chunkId] + ".chunk.js";
};